<template>
  <span class="k-brand__logo" :class="{ 'k-brand__logo--image': src && !broken, 'k-brand__logo--sm': small }">
    <img v-if="src && !broken" :src="src" alt="" class="k-brand__img" @error="broken = true">
    <template v-else>{{ initial }}</template>
  </span>
</template>

<script>
export default {
  name: "KCompanyLogo",
  props: {
    avatar: {
      type: String,
      default: "",
    },
    name: {
      type: String,
      default: "",
    },
    small: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      broken: false,
    };
  },
  computed: {
    src() {
      return this.avatar ? this.$functions.getImgLink(this.avatar, "medium") : "";
    },
    initial() {
      return (this.name || "K").charAt(0).toUpperCase();
    },
  },
  watch: {
    avatar() {
      this.broken = false;
    },
  },
};
</script>
